<template>
  <div id="app">
    <Header />
    <keep-alive>
      <router-view
        :key="$route.fullPath"
        @cargar="cargar()"
        @cargado="cargado()"
        @onError="atraparError"
      ></router-view>
    </keep-alive>
    <Footer />
    <b-modal
      id="modalCargando-1"
      v-model="modalCargando"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      size="sm"
    >
      <Cargando color="#000000" :tamanio="200" />
    </b-modal>
    <b-modal
      id="modalError-1"
      title="Ha ocurrido un error"
      v-model="modalError"
      size="sm"
      ok-only
    >
      {{ mensajeError }}
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/wrapper/Header";
import Footer from "@/components/wrapper/Footer";
import Cargando from "@/components/generales/Cargando";
import ApiDirectorio from "@/services/ApiDirectorio";
import ProcesaJsonParametros from "@/services/ProcesaJsonParametros";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Cargando
  },
  created() {
    this.obtieneParametros();
    this.obtieneParametrosJSON();
  },
  data() {
    return {
      modalCargando: false,
      modalError: false,
      mensajeError: "",
      mostrarVacantes: "",
      mostrarProcedimientosEspeciales: "",
      anioSiguiente: "",
      anioAnterior: "",
      etapaProceso: "", //Admite valores COMPLEMENTARIO / NORMAL ... Muestro / Oculta mensaje sobre establecimientos disponibles en la vitrina
      anioIndicadorCatDesempenioBasica: "",
      anioIndicadorCatDesempenioMedia: "",
      anioIndicadorCatSimceBasica: "",
      anioIndicadorCatSimceMedia: "",
      anioIndicadorCatDesarrolloSocial: "",
      anioIndicadorCatDesarrolloMedia: ""
    };
  },
  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function() {
      this.modalCargando = false;
    }
  },
  methods: {
    async obtieneParametrosJSON() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const parametrosJSON = await ProcesaJsonParametros.obtenerInformacion(
          this,
          tokenBearer
        );
        if (parametrosJSON.parametroInicioPostulacion) {
          localStorage.setItem(
            "anioSiguiente",
            parametrosJSON.parametroAnioSiguiente.valor
          );
          localStorage.setItem(
            "anioAnterior",
            parametrosJSON.parametroAnioAnterior.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesempenioBasica",
            parametrosJSON.parametroAnioIndicadorCatDesempenioBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesempenioMedia",
            parametrosJSON.parametroAnioIndicadorCatDesempenioMedia.valor
          );
          localStorage.setItem(
            "anioIndicadorCatSimceBasica",
            parametrosJSON.parametroAnioIndicadorCatSimceBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatSimceMedia",
            parametrosJSON.parametroAnioIndicadorCatSimceMedia.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesarrolloBasica",
            parametrosJSON.parametroAnioIndicadorCatDesarrolloBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesarrolloMedia",
            parametrosJSON.parametroAnioIndicadorCatDesarrolloMedia.valor
          );
          localStorage.setItem(
            "anioPostulacion",
            parametrosJSON.parametroAnioPostulacion.valor
          );
          localStorage.setItem(
            "anioAdmision",
            parametrosJSON.parametroAnioAdmision.valor
          );
          localStorage.setItem(
            "inicioPostulacion",
            parametrosJSON.parametroInicioPostulacion.valor
          );
          localStorage.setItem(
            "finPostulacion",
            parametrosJSON.parametroFinPostulacion.valor
          );
          localStorage.setItem(
            "fechaListaEspera",
            parametrosJSON.parametroFechaListaEspera.valor
          );
          localStorage.setItem(
            "fechaPeriodoComplementario",
            parametrosJSON.parametroFechaPeriodoComplementario.valor
          );
          localStorage.setItem(
            "fechaResultadosFinales",
            parametrosJSON.parametroFechaResultadosFinales.valor
          );
        } else {
          console.error("Error al procesar datos de JSON.");
        }
      } catch (error) {
        console.error("Error al procesar datos de JSON.", error);
      }
    },
    async obtieneParametros() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const etapaValor = await ApiDirectorio.obtenerInformacion(
          this,
          tokenBearer
        );
        if (etapaValor.resultadoEtapa) {
          localStorage.setItem("etapaVitrina", etapaValor.etapaVitrina);
          localStorage.setItem(
            "mostrarVacantes",
            etapaValor.parametroMostrarVacantes.valor
          );
          localStorage.setItem(
            "mostrarProcedimientosEspeciales",
            etapaValor.parametroMostrarProcedimientosEspeciales.valor
          );
        } else {
          console.error("No se obtuvo la etapa correctamente.");
        }
      } catch (error) {
        console.error("Error al cargar la etapa:", error);
      }
    },
    //atrapa error y muestra modal con informacion correspondiente
    atraparError(mensaje) {
      this.mensajeError = mensaje;
      this.modalError = true;
    },
    //muestra modal cargando
    cargar() {
      this.modalCargando = true;
    },
    //quita modal de cargando
    cargado() {
      this.modalCargando = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue